// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:32:35

export default {
  "id": "word-mine",
  "slug": "word-mine",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/b0cc3d7cdae0458eb371d8665eb31b8f-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/b0cc3d7cdae0458eb371d8665eb31b8f/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Word Mine",
      "description": "Word Mine takes you on a thrilling journey where letters are your treasure! Dive into a world of scrambled chaos and uncover hidden words buried in the grid. With every move, you’ll strike gold, revealing secrets that push you closer to victory. Sharpen your mind, follow the clues, and let the adventure unfold—one word at a time!",
      "instructions": "1.Rearrange Letters:\nDrag and drop the scrambled letters on the grid to form meaningful words.\n2.Follow Color Hints:\nGreen Tile: The letter is in the correct position.\nYellow Tile: The letter is in the correct row or column but not the exact spot.\nWhite Tile: The letter is in the wrong position entirely.\n3. Find All Words:\nEach level has a set of valid words hidden in the grid.\n4. Unlock New Levels:\nProgress through increasingly challenging puzzles, with more complex grids.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "crossword",
        "wordscapes",
        "wordsearch"
      ]
    },
    "zh-CN": {
      "title": "单词矿场",
      "description": "字母矿洞带你踏上一场惊心动魄的寻宝之旅！投身于一片混乱的字母世界，发掘隐藏在网格中的秘密单词。每走一步，你都将发现宝藏，揭示推动你向胜利迈进的秘密。磨练你的智慧，跟随线索，让冒险一次一个单词地展开！",
      "instructions": "1. 字母重排：\n将打乱的字母拖放到网格中，形成有意义的单词。\n2. 跟随颜色提示：\n绿色瓷砖：字母处于正确的位置。\n黄色瓷砖：字母处于正确的行或列，但不是确切的位置。\n白色瓷砖：字母完全处于错误的位置。\n3. 找出所有单词：\n每个关卡都隐藏在网格中的一组有效单词。\n4. 解锁新关卡：\n通过越来越具有挑战性的谜题，解锁更复杂的网格。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "填字游戏",
        "单词迷",
        "单词搜索"
      ]
    },
    "zh-TW": {
      "title": "單詞礦藏",
      "description": "Word Mine帶你踏上驚險的冒險之旅，字詞是你的財寶！跳入一個混亂的拼湊世界，挖掘藏在格線中的隱藏單詞。隨著每一次移動，你將挖掘到黃金，揭示帶你更接近勝利的秘密。鍛鍊你的思維，追蹤線索，讓冒險一次一字地展開！",
      "instructions": "1. 重排字母：\n將混亂的字母拖放到格子上，形成有意义的單詞。\n2. 跟隨顏色提示：\n綠色方塊：字母位於正確的位置。\n黃色方塊：字母位於正確的行或列，但不是精確的位置。\n白色方塊：字母完全位於錯誤的位置。\n3. 找到所有單詞：\n每個關卡都有一組隱藏在格子中的有效單詞。\n4. 解鎖新關卡：\n通過逐漸增加難度的謎題，使用更複雜的格子進行進步。",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "填字遊戲",
        "拼字天地",
        "找字遊戲"
      ]
    },
    "zh-HK": {
      "title": "單詞礦場",
      "description": "Word Mine 帶你踏上刺激的旅程，字母是你的珍寶！跳入一個混亂的亂局世界，發現埋藏在格中的隱藏單詞。每一次移動，你將發現黃金，揭示帶你更接近勝利的秘密。鍛鍊你的思維，跟隨線索，讓冒險逐字逐句展開！",
      "instructions": "1. 重排字母：\n將混亂的字母拖放到格子上，形成有意义的單詞。\n2. 跟隨顏色提示：\n綠色磁磚：字母位於正確的位置。\n黃色磁磚：字母位於正確的行或列，但不是正確的位置。\n白色磁磚：字母完全位於錯誤的位置。\n3. 找到所有單詞：\n每個關卡都有一組隱藏在格子中的有效單詞。\n4. 解鎖新關卡：\n通過越來越挑戰性的謎題，使用更複雜的格子進行進度。",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "字彙迷",
        "字畫天地",
        "單字搜索"
      ]
    },
    "ja": {
      "title": "ワードマイン",
      "description": "Word Mineは、あなたを文字が宝物の冒険に誘います！混乱する謎の世界に飛び込み、グリッドに隠された言葉を発見しましょう。それぞれの手がかりで、金を掘り当て、勝利に近づく秘密を明らかにします。頭を切れ長く、ヒントに従い、一つ一つの言葉で冒険が展開していきます！",
      "instructions": "1. 文字の並び替え:\nグリッド上に混ざった文字をドラッグ＆ドロップして意味のある単語を作成します。\n2. 色のヒントに従う:\n緑のタイル: 文字が正しい位置にあります。\n黄色のタイル: 文字が正しい行や列にありますが、正確な場所ではありません。\n白色のタイル: 文字が全く間違った位置にあります。\n3. 全ての単語を見つける:\n各レベルにはグリッドに隠された有効な単語のセットがあります。\n4. 新しいレベルを解除:\n次第に難しくなるパズルを進み、より複雑なグリッドで新しいレベルを解除します。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "クロスワード",
        "ワードスカapes",
        "ワードサーチ"
      ]
    },
    "ko": {
      "title": "워드 마인",
      "description": "Word Mine은 글자들이 보물로 되어 있는 흥미진진한 여행을 안겨줍니다! 혼란스러운 스쳐지른 세상에 뛰어들어 그리드 속에 가려진 숨겨진 단어를 발견하세요. 매번 움직이면 금을 발견하며, 승리에 가까워지는 비밀을 밝혀냅니다. 머리를 날카롭게 하고, 힌트를 따라 모험을 펼쳐보세요—한 단어씩!",
      "instructions": "1. 문자 재정렬:\n그리드에 망라된 문자를 드래그 앤 드롭하여 의미 있는 단어를 만들어주세요.\n2. 색상 힌트 따라가기:\n초록 타일: 문자가 정확한 위치에 있습니다.\n노란 타일: 문자가 정확한 행이나 열에 있지만 정확한 위치에 아닙니다.\n하얀 타일: 문자가 완전히 잘못된 위치에 있습니다.\n3. 모든 단어 찾기:\n각 레벨마다 그리드에 숨겨진 유효한 단어셋이 있습니다.\n4. 새 레벨 해금:\n일어나는 도전적인 퍼즐을 통해 더 복잡한 그리드로 진행해주세요.",
      "genres": [
        "캐주얼",
        "파uzzle"
      ],
      "tags": [
        "단어クロ스",
        "워드스케이프",
        "단어찾기"
      ]
    },
    "fr": {
      "title": "Mot Minier",
      "description": "Word Mine vous emmène dans un voyage captivant où les lettres sont votre trésor ! Plongez dans un monde de chaos mélangé et découvrez des mots cachés enfouis dans la grille. À chaque déplacement, vous trouverez de l’or, révélant des secrets qui vous rapprochent de la victoire. Affûtez votre esprit, suivez les indices et laissez l’aventure se dérouler – mot après mot !",
      "instructions": "1. Réarrangez les lettres :\nFaites glisser et déposez les lettres mélangées sur la grille pour former des mots significatifs.\n2. Suivez les indices de couleur :\nTuile verte : La lettre est à la position correcte.\nTuile jaune : La lettre est à la bonne rangée ou colonne mais pas à l'endroit exact.\nTuile blanche : La lettre est complètement à la mauvaise position.\n3. Trouvez tous les mots :\nChaque niveau cache un ensemble de mots valides dans la grille.\n4. Débloquez de nouveaux niveaux :\nAvancez dans des puzzles de plus en plus complexes, avec des grilles plus complexes.",
      "genres": [
        "Facile",
        "Puzzle"
      ],
      "tags": [
        "croisé",
        "wordscapes",
        "mots-croisés"
      ]
    }
  }
};
